import { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import { Button } from "../components/ui/button";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_3bee16da-1518-4ecf-84ec-23daebfe4616/artifacts/lxb7r3r0_Cybertech%20Prefects%20Logo%20New.png";

const NAV_LINKS = [
  { label: "Services", href: "#services" },
  { label: "About", href: "#about" },
  { label: "Testimonials", href: "#testimonials" },
  { label: "Contact", href: "#contact" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="header"
      className={`fixed top-0 w-full z-50 glass-header transition-all duration-300 ${
        scrolled
          ? "bg-[#0A0A0B]/80 border-b border-white/10"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between h-16 md:h-20">
        {/* Logo */}
        <a href="#hero" data-testid="header-logo" className="flex items-center gap-3">
          <img
            src={LOGO_URL}
            alt="CyberTech Prefects"
            className="h-10 md:h-12 w-auto"
          />
        </a>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8">
          {NAV_LINKS.map((link) => (
            <a
              key={link.href}
              href={link.href}
              data-testid={`nav-${link.label.toLowerCase()}`}
              className="text-sm font-medium text-zinc-400 hover:text-white transition-colors"
            >
              {link.label}
            </a>
          ))}
          <a href="#contact">
            <Button
              data-testid="header-cta"
              className="bg-[#B87333] hover:bg-[#A6632B] text-white rounded-md px-5 py-2 text-sm font-medium transition-all"
            >
              Get Assessment
            </Button>
          </a>
        </nav>

        {/* Mobile Menu Button */}
        <button
          data-testid="mobile-menu-toggle"
          className="md:hidden text-white"
          onClick={() => setMobileOpen(!mobileOpen)}
        >
          {mobileOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile Menu */}
      {mobileOpen && (
        <div className="md:hidden bg-[#0A0A0B]/95 backdrop-blur-xl border-t border-white/10 px-6 py-6 space-y-4">
          {NAV_LINKS.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={() => setMobileOpen(false)}
              className="block text-base text-zinc-300 hover:text-white transition-colors"
            >
              {link.label}
            </a>
          ))}
          <a href="#contact" onClick={() => setMobileOpen(false)}>
            <Button className="w-full bg-[#B87333] hover:bg-[#A6632B] text-white mt-2">
              Get Assessment
            </Button>
          </a>
        </div>
      )}
    </header>
  );
}
